<template>
  <div class="bg-chart">
    <!-- <div class="text-bold text-center">SLA Performance</div> -->
    <div style="display: flex; flex-direction: column; height: 100%; overflow-x: auto">
      <div class="doughnat-container">
        <div class="text-bold text-center">{{ labels }}</div>
        <pie-chart :chartData="chartData" :options="chartOptions" :styles="{ height: '75%', listStyleType: 'none' }"
          v-if="tiket" />
        <div class="chart-text-center">{{ level }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: '',
      chartData: {
        labels: [
          'Sangat Puas',
          'Puas',
          'Cukup Puas',
          'Buruk',
          'Sangat Buruk',
          'Tidak Merespon',
        ],
        datasets: [
          {
            backgroundColor: [
              '#990000',
              '#ff3333',
              '#ff9900',
              '#ffabae',
              '#ed1c24',
              '#808080',
            ],
            data: [0, 0, 0, 0, 0, 0],
          },
        ],
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
          labels: {
            fontSize: 12,
            boxWidth: 12,
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              const value = data.datasets[0].data[tooltipItem.index]
              const total = data.datasets[0].data.reduce((a, b) => a + b, 0)
              return `${label}: ${value}%`
            },
          },
        },
      },

      level: 'L1',
    }
  },
  computed: {
    tiket() {
      const ticket = this.$store.state.kpiStore.tiket_selesai
      this.setChart()

      return ticket
    },
    for_csi_value() {
      const data = this.$store.state.kpiStore.for_csi_value

      return data
    },
  },
  async created() {
    await this.setChart()
  },
  methods: {
    calculateLevel() {
      let {
        startL5Responden,
        endL5Responden,
        startL4Responden,
        endL4Responden,
        startL3Responden,
        endL3Responden,
        startL2Responden,
        endL2Responden,
        startL1Responden,
        endL1Responden,
        startL5Nilai,
        endL5Nilai,
        startL4Nilai,
        endL4Nilai,
        startL3Nilai,
        endL3Nilai,
        startL2Nilai,
        endL2Nilai,
        startL1Nilai,
        endL1Nilai,
      } = this.for_csi_value

      const puas = Number(this.$store.state.kpiStore.puas)
      const sangat_puas = Number(this.$store.state.kpiStore.sangat_puas)
      const tidak_puas =
        Number(this.$store.state.kpiStore.cukup_puas) +
        Number(this.$store.state.kpiStore.buruk) +
        Number(this.$store.state.kpiStore.sangat_buruk)
      const responden =
        Number(this.$store.state.kpiStore.responden) +
        Number(this.$store.state.kpiStore.system_responden)
      const ticket = Number(this.$store.state.kpiStore.tiket_selesai)

      const totalResponden = Math.round((responden / ticket) * 100)
      const totalNilai = Math.round(((puas + sangat_puas) / responden) * 100)

      let calResponden = 0
      let calNilai = 0
      let level = 0

      if (
        totalResponden >= startL5Responden &&
        totalResponden <= endL5Responden
      )
        calResponden = 5
      if (
        totalResponden >= startL4Responden &&
        totalResponden <= endL4Responden
      )
        if (calResponden <= 5) {
          calResponden = 4
        }
      if (
        totalResponden >= startL3Responden &&
        totalResponden <= endL3Responden
      )
        if (calResponden <= 4) {
          calResponden = 3
        }
      if (
        totalResponden >= startL2Responden &&
        totalResponden <= endL2Responden
      )
        if (calResponden <= 2) {
          calResponden = 2
        }
      if (
        totalResponden >= startL1Responden &&
        totalResponden <= endL1Responden
      )
        if (calResponden <= 1) {
          calResponden = 1
        }

      if (totalNilai >= startL5Nilai && totalNilai <= endL5Nilai) calNilai = 5
      if (totalNilai >= startL4Nilai && totalNilai <= endL4Nilai) calNilai = 4
      if (totalNilai >= startL3Nilai && totalNilai <= endL3Nilai) calNilai = 3
      if (totalNilai >= startL2Nilai && totalNilai <= endL2Nilai) calNilai = 2
      if (totalNilai >= startL1Nilai && totalNilai <= endL1Nilai) calNilai = 1

      if (calResponden >= calNilai) {
        level = calNilai
      }
      if (calResponden <= calNilai) {
        level = calResponden
      }

      switch (level) {
        case 5:
          this.level = 'L5'
          break
        case 4:
          this.level = 'L4'
          break
        case 3:
          this.level = 'L3'
          break
        case 2:
          this.level = 'L2'
          break
        case 2:
          this.level = 'L2'
          break
        case 1:
          this.level = 'L1'
          break

        default:
          break
      }
    },
    setChart() {
      const ticket = Number(this.$store.state.kpiStore.tiket_selesai)
      const not_yet = Number(this.$store.state.kpiStore.not_yet_assessed)

      const sangat_puas = (
        (Number(this.$store.state.kpiStore.sangat_puas) / ticket) *
        100
      ).toFixed(2)
      const puas = (
        (Number(this.$store.state.kpiStore.puas) / ticket) *
        100
      ).toFixed(2)
      const cukup_puas = (
        (Number(this.$store.state.kpiStore.cukup_puas) / ticket) *
        100
      ).toFixed(2)
      const buruk = (
        (Number(this.$store.state.kpiStore.buruk) / ticket) *
        100
      ).toFixed(2)
      const sangat_buruk = (
        (Number(this.$store.state.kpiStore.sangat_buruk) / ticket) *
        100
      ).toFixed(2)
      const tidak_respon = (
        (Number(this.$store.state.kpiStore.not_yet_assessed) / ticket) *
        100
      ).toFixed(2)

      if (ticket > 0 && not_yet >= 0) {
        this.chartData = {
          labels: [
            'Sangat Puas',
            'Puas',
            'Cukup Puas',
            'Buruk',
            'Sangat Buruk',
            'Tidak Merespon',
          ],
          datasets: [
            {
              backgroundColor: [
                '#990000',
                '#ff3333',
                '#ff9900',
                '#ffabae',
                '#ed1c24',
                '#808080',
              ],
              data: [
                sangat_puas,
                puas,
                cukup_puas,
                buruk,
                sangat_buruk,
                tidak_respon,
              ],
            },
          ],
        }
      } else {
        this.chartData = {
          labels: [
            'Sangat Puas',
            'Puas',
            'Cukup Puas',
            'Buruk',
            'Sangat Buruk',
            'Tidak Merespon',
          ],
          datasets: [
            {
              backgroundColor: [
                '#990000',
                '#ff3333',
                '#ff9900',
                '#ffabae',
                '#ed1c24',
                '#808080',
              ],
              data: [0, 0, 0, 0, 0, 0],
            },
          ],
        }
      }

      this.calculateLevel()
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 100%;
  height: 50vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-text-center {
  position: absolute;
  top: 50%;
  left: 30%;
  transform: translateX(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  font-weight: bold;
  color: grey;
}

.bg-chart {
  display: flex;
  justify-content: center;
  background-color: rgb(237, 231, 231);
  border-radius: 8px;
  box-shadow: 0 1px 5px 3px gray;
  padding: 0.5rem 1rem;
  max-height: 60vh;
}
</style>
